import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/Header/Header";
import QuestCard from "../../components/common/Card/CardQuest";
import { useLazyGetQuestListQuery } from "../../services/apiSlice";
import LoadingCommon from "../../components/common/LoadingStatus/LoadingCommon";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OnGoing = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [state, setState] = useState({
    isMenuOpen: false,
    page: 1,
    limit: 10,
    hasMore: true,
  });
  const observerRef = useRef(null);

  const [getListQuests, { data, isFetching }] = useLazyGetQuestListQuery();

  useEffect(() => {
    getListQuests({
      page: state.page,
      limit: state.limit,
      status: "",
    });
  }, [getListQuests, state.page, state.limit]);

  useEffect(() => {
    if (!state.hasMore || !data?.total) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setState((prevState) => {
            if (prevState.limit >= data?.total) {
              return { ...prevState, hasMore: false };
            }
            return { ...prevState, limit: prevState.limit + 5 };
          });
        }
      },
      { threshold: 1.0 }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => observer.disconnect();
  }, [state.hasMore, data?.total]);

  const fakeQuest = {
    vaddress: "123",
    description: "Description for Research 2025 Year",
    est_time: "10",
    expire_time: "2025-12-31T23:59:59",
    id: "ab1f8916-ca4f-44af-8859-b6aedc5aa463",
    latitude: "10.762622",
    longitude: "106.660172",
    max_slot: 100,
    name: "Research 2025 Year",
    requirement: "Requirement 9",
    slot_handle: 100,
    status: "COMPLETED",
    token: "10",
  };

  const questList = [...(data?.data || []), fakeQuest];

  return (
    <>
      <LoadingCommon statusLoading={isFetching} />
      <div className="flex flex-col mx-auto w-full max-w-[480px]">
        <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
          <Header title={t("home.ongoing.quests")} />
        </div>
        <div className="h-32"></div>

        <div className="flex flex-col flex-1 p-3.5 w-full">
          {questList.map((quest, index) => (
            <QuestCard
              key={index}
              {...quest}
              responses={quest.slot_handle}
              totalResponses={quest.max_slot}
              endTime={quest.expire_time}
              isCompleted={quest.status === "ONGOING" ? false : true}
              handleView={() => navigate(`/quest/details/${quest.id}`)}
              handleTaskQuest={() => navigate(`/quest/result`)}
              handleToPerforman={() => navigate(`/performan`)}
            />
          ))}
          {state.hasMore && (
            <div ref={observerRef} className="h-10 w-full bg-transparent"></div>
          )}
        </div>
      </div>
    </>
  );
};

export default OnGoing;
